export const INITIALIZE_PLANNER_UI = 'planner/INITIALIZE_PLANNER_UI';
export const SET_PLANNER_CURRENT_VIEW = 'planner/SET_PLANNER_CURRENT_VIEW';
export const SET_PLANNER_WEEK_STYLE = 'planner/SET_PLANNER_WEEK_STYLE';
export const SET_PLANNER_GRID_VIEW = 'planner/SET_PLANNER_GRID_VIEW';
export const SET_PLANNER_SHOW_REMINDERS = 'planner/SET_PLANNER_SHOW_REMINDERS';
export const SET_PLANNER_CALENDAR_VIEW = 'planner/SET_PLANNER_CALENDAR_VIEW';
export const SET_PLANNER_START_DATE = 'planner/SET_PLANNER_START_DATE';
export const SET_PLANNER_END_DATE = 'planner/SET_PLANNER_END_DATE';
